import { Box, Heading } from '@hover/blueprint';
import React from 'react';
import { animated, useSpring } from 'react-spring';

import { BackgroundLogo } from 'src/modules/designStudio/components/BackgroundLogo';
import { animationConfig } from 'src/modules/designStudio/helpers/animationConfig';
import {
  Robots as MetaRobots,
  Title as MetaTitle,
} from 'src/shared/components/Meta';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

export const InteractiveRenderingNotFoundPage = () => {
  const props = useSpring(animationConfig.loaderAnimation);
  const t = useTranslate(TranslationNamespace.NOT_FOUND);
  return (
    <Box
      alignItems="center"
      backgroundColor="primary.base"
      bottom={0}
      flex={1}
      justifyContent="center"
      left={0}
      overflow="hidden"
      paddingX={400}
      position="absolute"
      right={0}
      top={0}
    >
      <MetaRobots mode="none" />
      <MetaTitle title={t('pageNotFound')} />
      <BackgroundLogo />
      <animated.div style={props}>
        <Heading color="neutral.0" size={700}>
          404
        </Heading>
      </animated.div>
    </Box>
  );
};
